export default "__VITE_ASSET__Bs4Xy1CP__"